import { useQuery } from '@tanstack/react-query';
import { getTagList } from '../../api/tag.ts';

export function useTagList() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: async () => {
      return await getTagList();
    },
  });
}
